import { useState, useEffect } from 'react';
import axios from 'axios';
import { ClipboardText, CheckCircle, WarningCircle, Spinner } from '@phosphor-icons/react';
import { fmtDay } from '@/utils/dateFmt';

const API = process.env.REACT_APP_BACKEND_URL;

export default function PreConsultationAuditPage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/api/admin/pre-consultation-audit`);
        setData(data);
      } catch {
        setError('Erro ao carregar a auditoria.');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="max-w-3xl mx-auto px-4 py-6" data-testid="pre-consultation-audit-page">
      <div className="flex items-center gap-2 mb-1">
        <ClipboardText size={22} weight="duotone" className="text-brand-green" />
        <h1 className="font-heading font-semibold text-xl text-brand-text">Auditoria Pré-Consulta</h1>
      </div>
      <p className="text-sm text-brand-muted mb-5">
        Pacientes que já tiveram pelo menos 1 consulta e o respetivo estado do questionário de pré-consulta.
      </p>

      {loading ? (
        <div className="text-center py-10"><Spinner size={28} className="mx-auto animate-spin text-brand-green" /></div>
      ) : error ? (
        <p className="text-sm text-red-500" data-testid="audit-error">{error}</p>
      ) : (
        <>
          <div className="flex gap-3 mb-4" data-testid="audit-summary">
            <div className="bg-white border border-brand-border rounded-2xl px-4 py-3 flex-1 text-center">
              <p className="text-2xl font-heading font-semibold text-brand-text">{data.total}</p>
              <p className="text-[10px] text-brand-muted">Pacientes com consultas</p>
            </div>
            <div className="bg-white border border-brand-border rounded-2xl px-4 py-3 flex-1 text-center">
              <p className={`text-2xl font-heading font-semibold ${data.pending > 0 ? 'text-red-500' : 'text-brand-green'}`}>{data.pending}</p>
              <p className="text-[10px] text-brand-muted">Questionário pendente</p>
            </div>
          </div>

          {data.patients.length === 0 ? (
            <p className="text-center text-brand-muted py-8">Sem pacientes com consultas ainda.</p>
          ) : (
            <div className="space-y-1.5" data-testid="audit-list">
              {data.patients.map(p => (
                <div key={p.patient_id} className="bg-white border border-brand-border rounded-xl p-3 flex items-center justify-between" data-testid={`audit-row-${p.patient_id}`}>
                  <div>
                    <p className="text-sm font-medium text-brand-text">{p.name}</p>
                    <p className="text-[11px] text-brand-muted">
                      <span className="bg-brand-bg px-2 py-0.5 rounded-full mr-2">{p.patient_type || '-'}</span>
                      1.ª consulta: {p.first_consultation_date ? fmtDay(p.first_consultation_date) : '-'}
                    </p>
                  </div>
                  {p.questionnaire_filled ? (
                    <span className="flex items-center gap-1 text-[11px] font-medium text-brand-green bg-brand-mint/20 px-2.5 py-1 rounded-full" data-testid="status-filled"><CheckCircle size={13} /> Preenchido</span>
                  ) : (
                    <span className="flex items-center gap-1 text-[11px] font-medium text-red-600 bg-red-50 px-2.5 py-1 rounded-full" data-testid="status-pending"><WarningCircle size={13} /> Pendente</span>
                  )}
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}
